import { useState } from "react";
import { toast } from "sonner";
import { Crown, KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ProCard = ({ access }) => (
  <section className="card p-5 sm:p-6 border-[#22D3EE]/40" data-testid="pro-card">
    <h2 className="font-head font-bold text-lg flex items-center gap-2"><Crown className="w-5 h-5 text-amber-300" /> Go Pro — $4.99/month</h2>
    <ul className="text-sm text-slate-300 mt-2 space-y-1 list-disc pl-5">
      <li>All the details: live charts, track record, accuracy reports</li>
      <li>Practice bot, rules and history</li>
      <li>Cancel any time. Unlocks on this device.</li>
    </ul>
    <button onClick={() => access.upgrade().catch(() => toast.error("Couldn't start checkout"))} data-testid="pro-upgrade-btn"
      className="mt-4 px-6 py-3 rounded-full bg-[#22D3EE] hover:bg-[#06B6D4] text-[#03141A] font-semibold transition-colors">Upgrade to Pro</button>
  </section>
);

export const OwnerButton = ({ access }) => {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  if (access.owner) return <button onClick={access.logout} className="text-xs text-slate-500 hover:text-slate-300" data-testid="owner-logout-btn">Owner: signed in · sign out</button>;
  const go = async () => {
    try { await access.login(pin); toast.success("Owner mode on"); setOpen(false); }
    catch (e) { toast.error(e.response?.data?.detail || "Wrong PIN"); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="text-xs text-slate-500 hover:text-slate-300 flex items-center gap-1" data-testid="owner-login-btn"><KeyRound className="w-3 h-3" />Owner</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B1220] border-[#1A2338] text-slate-100 max-w-sm" data-testid="owner-dialog">
          <DialogHeader><DialogTitle>Owner sign-in</DialogTitle><DialogDescription className="text-slate-400">Enter your owner PIN to see your account and control trading.</DialogDescription></DialogHeader>
          <Input type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="PIN" className="bg-[#05070D] border-[#1A2338] h-11" data-testid="owner-pin-input" />
          <button onClick={go} className="py-3 rounded-full bg-[#22D3EE] text-[#03141A] font-semibold" data-testid="owner-pin-submit">Sign in</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
